export const siteURL = process.env.REACT_APP_MAIN_SITE_URL
export const baseURL = process.env.REACT_APP_MAIN_BASE_URL
export const salesforceBaseURL = process.env.REACT_APP_SALESFORCE_API_BASE_URL

export const radarAPIURL = process.env.REACT_APP_RADAR_API_BASE_URL
export const radarSKAPIKey = process.env.REACT_APP_RADAR_SK_API_KEY
export const radarPKAPIKey = process.env.REACT_APP_RADAR_PK_API_KEY

export const q4magicSyncURL = baseURL + '/syncToQ4Magic'
export const syncFromQ4magicURL = baseURL + '/syncFromQ4Magic'
export const syncStatusURL = baseURL + '/syncStatus'

export const authIdURL = baseURL + '/authIdDetails'
export const countryURL = baseURL + '/country'
export const stateURL = baseURL + '/state'
export const fileUploadURL = baseURL + '/uploadFile'
export const dnsMxURL = baseURL + '/dns/mx'

export const customersURL = baseURL + '/customers'
export const rolesURL = baseURL + '/roles'
export const businessInfoURL = baseURL + '/businessInfo'

export const salesforceAccountURL = salesforceBaseURL + '/account'
export const accountURL = baseURL + '/account'
export const crmURL = baseURL + '/crm'
export const opportunityURL = baseURL + '/opportunities'
export const opportunitiesDocumentsURL = baseURL + '/opportunitiesDocuments'
export const opportunityPartnerURL = baseURL + '/opportunityPartner'
export const opportunitiesProductURL = baseURL + '/opportunitiesProduct'
export const opportunitiesContactURL = baseURL + '/opportunitiesContact'
export const opportunitiesNotesURL = baseURL + '/opportunitiesComment'
export const opportunitiesCurrentEnvironmentURL = baseURL + '/opportunitiesCurrentEnvironment'
export const opportunitiesContactNoteURL = baseURL + '/opportunitiesContactNote'

export const docsAttachmentsURL = baseURL + '/docsAttachments'
export const docsCategoryURL = baseURL + '/docsCategory'

export const syncRecordsURL = baseURL + '/syncRecords'
export const contactURL = baseURL + '/contact'
export const paymentGatewayURL = baseURL + '/paymentGateway'
export const functionalityURL = baseURL + '/functionality'
export const moduleURL = baseURL + '/module'
export const actionURL = baseURL + '/actions'
export const subUserTypeURL = baseURL + '/subUserType'
export const teamDetailsURL = baseURL + '/teamDetails'
export const teamMembersURL = baseURL + '/teamMembers'
export const customerQuotaURL = baseURL + '/customerQuota'
export const todoURL = baseURL + '/todo'
export const todoAssignURL = baseURL + '/todoAssign'
export const todoNoteURL = baseURL + '/todoNote'
export const todoAttachmentsURL = baseURL + '/todoAttachments'

export const tempMailURL = baseURL + '/tempMail'
export const emailScrapingRequestURL = baseURL + '/emailScrapingRequest'
export const productsUrl = baseURL + '/products'

export const processNameURL = baseURL + '/process-name'
export const salesProcessURL = baseURL + '/sales-process'
export const salesStageURL = baseURL + '/salesStage'
export const googleCalendarURL = baseURL + '/google-calendar'
export const outlookCalendarUrl = baseURL + '/outlookCalendar'
export const timeZonesURL = baseURL + '/time-zones'
export const calendarURL = baseURL + '/calendar'
export const calendarAppointmentEventTypeURL = baseURL + '/calendarAppointmentEventType'
export const calendarAppointmentURL = baseURL + '/calendarAppointment'

export const closeplanURL = baseURL + '/closeplan'
export const closePlanNotesURL = baseURL + '/closeplannotes'
export const meetingURL = baseURL + '/meeting'
export const meetingAttendeesURL = baseURL + '/meeting-attendees'
export const meetingSummaryURL = baseURL + '/meetingSummary'
export const notesURL = baseURL + '/notes'
export const resultsURL = baseURL + '/results'
export const activitiesURL = baseURL + '/activities'
export const performanceURL = baseURL + '/performance'

export const subscriptionRatesURL = baseURL + '/subscriptionRates'

export const calenderName = '360Pipe Calendar'